import { SaleFormInput } from '@src/core/buyerApiClient';

export const countFormInputs = (inputs: Array<SaleFormInput[]>): number =>
  inputs.reduce((acc, value) => acc + value.length, 0);
